import { render, staticRenderFns } from "./BookAudiosSelector.vue?vue&type=template&id=0b432e40&scoped=true"
import script from "./BookAudiosSelector.vue?vue&type=script&lang=js"
export * from "./BookAudiosSelector.vue?vue&type=script&lang=js"
import style0 from "./BookAudiosSelector.vue?vue&type=style&index=0&id=0b432e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b432e40",
  null
  
)

export default component.exports